<template>
    <div class="container">
          <div class="wrap">
              <pageHeader/>
              <pageBack/>
              <model-viewer camera-controls :auto-rotate="autoRotate" :rotation-per-second="rotationSpeed" 
                :src="url" shadow-intensity="1" @load="onModelLoaded" @error="onModelError" 
                touch-action="pan-y">
              </model-viewer>
              <!-- 加载中的提示 -->
                <!-- <div v-if="isLoading" class="loading">
                    <van-loading color="#fff" vertical>加载中...</van-loading>
                </div> -->
              <!-- https://test.sc.cloudyiso.com/yu/new.glb -->
              <div class="menu">
                  <div @click="toggleRotation()">
                      <img src="../../assets/rotate.png" alt="" srcset="">
                      <p>{{autoRotate?'暂停':'开始'}}旋转</p>
                  </div>
                  
                  <div class="start-btn" @click="openPop()">
                      <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                      <p>
                      <span>去购买</span>
                      </p>
                  </div>
                  <div @click="to_link()">
                      <img src="../../assets/switch.png" alt="" srcset="">
                      <p>重新换装</p>
                  </div>
              </div>
              <div class="popup" v-if="showPop">
                  <div class="popup-content">
                      <img :src="qrcodeSrc" alt="" srcset="" class="qrcode">
                      <div class="popup-text">
                          <p>使用手机扫描二维码</p>
                          <p>去购买</p>
                      </div>
                      <img src="../../assets/Vector.png" alt="" srcset="" class="close" @click="closePop()">
                  </div>
              </div>
          </div>
          <pagePop status='fitting' v-if="isLoading" @goBack="goBack()" />
      </div>
  </template>
  <script>
  import ModelViewer from '@google/model-viewer'
  import {h5qrcode,getInfo} from '@/api/user'
  import { Toast } from 'vant';
  import pagePop from '../../components/popup.vue'
  export default {
    name:'aiEffect',
    components: {
        ModelViewer,
        pagePop
    },
  data() {
    return {
        showPop:false,
        autoRotate: true, // 控制自动旋转的状态
        qrcodeSrc:require('@/assets/gw.png'),
        rotationSpeed: '20deg',
        url:'',
        isLoading: true // 是否正在加载
    }
  },
  methods: {
    onModelLoaded() {
      this.isLoading = false;
      console.log('模型加载完成');
    },
    goBack(){
        this.$router.go(-1)
    },
    // 模型加载失败时触发
    onModelError(error) {
      this.isLoading = false;
      Toast('3D试衣效果加载失败！');
      let that = this
      setTimeout(() => {
        that.goBack()
      }, 2500);
      console.error('模型加载失败:', error);
    },
    toggleRotation() {
      this.autoRotate = !this.autoRotate; // 切换旋转状态
    },
    openPop(){
        this.showPop = true
    },
    closePop(){
        this.showPop = false;
    },
    to_link(){
        this.$router.push('/selectParts')
    },
    qrcode(){
        // localStorage.getItem('taskId')
        h5qrcode({id: localStorage.getItem('taskId')}).then(res => {
            if (res.code && res.code === 1) {
                this.qrcodeSrc = res.data;
            } else {
                Toast(res.msg);
            }
        })
        getInfo({id:localStorage.getItem('taskId')}).then((res) => {
          if (res.code === 1) {
            this.url = res.data.img3d
          }else{
            Toast(res.msg)
          }
      });
    }
  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
    this.qrcode()
    // Toast.loading({
    //     message: '加载中...',
    //     forbidClick: true,
    //     duration: 2000
    //   });
  }
}
  </script>
  <style src="./index.less" scoped lang="less"></style>